import TransactionIndividual from './TransactionIndividual'

export default TransactionIndividual
